var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38859 0L12.1602 1.30224L5.57992 7.98339H0L6.38859 0ZM0.250977 9.98339H5.57992L13.1347 17.6539V23.0646L10.9298 20.8258L0.250977 9.98339ZM15.1347 23.0646V17.6539L22.6895 9.98339H28.0184L17.3396 20.8258L15.1347 23.0646ZM28.2694 7.98339H22.6895L16.1092 1.30224L21.8808 0L28.2694 7.98339ZM7.40217 8.98339L14.1347 2.14769L20.8672 8.98339L14.1347 15.8191L7.40217 8.98339Z",
    fill: "#FFC90D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHome);
export default __webpack_public_path__ + "static/media/heart_home.4c0f3e2affe929307ba20b0de7c38d78.svg";
export { ForwardRef as ReactComponent };